import { render, staticRenderFns } from "./powerValueView.vue?vue&type=template&id=36334238&scoped=true&"
import script from "./powerValueView.vue?vue&type=script&lang=js&"
export * from "./powerValueView.vue?vue&type=script&lang=js&"
import style0 from "./powerValueView.vue?vue&type=style&index=0&id=36334238&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36334238",
  null
  
)

export default component.exports